import {Theme, withStyles} from '@logistics-frontend/blocks'
import {Alert} from '@logistics-frontend/blocks/legacy'

export default withStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(0, 1.6),
      alignItems: 'center',
      borderRadius: 0,
    },
    standardWarning: {
      '& $icon': {
        width: 24,
        height: 24,
        padding: 0,
      },
    },
  }),
  {name: 'NotificationAlert'},
)(Alert)
